import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';

export default () =>
    getFallbackValueIfNull(
        getStore().reminderToast,
        getUserConfiguration().UserOptions.EnableReminders
    );
